import { MOCK_WORK_ORDERS } from "../data";
import { DiagramDepartmentTab, WorkOrderDetailTab, WorkOrderState } from "../types";

export const initialDiagramView = {
  activeDepartment: DiagramDepartmentTab.DIAGRAM,
  activePage: 0,
  pages: [],
};

export const initialState: WorkOrderState = {
  loading: false,
  detailLoading: false,
  error: null,
  statusFilter: "ALL",
  workOrders: MOCK_WORK_ORDERS,
  selectedWorkOrderId: null,
  vehicleDetails: null,
  vehicleDetailsForm: null,
  boxDetailsForm: null,
  weightAndWallForm: null,
  loadDistributionForm: null,
  addOnDetails: null,
  quotationForm: null,
  quotationBoxStructure: null,
  quotationTyingEquipment: null,
  quotationSafetyVehicle: null,
  quotationLocks: null,
  quotationStandard95: null,
  centreOfGravityForm: null,
  chassisLoads: null,
  vehicleMeasures: null,
  additionalEquipment: null,
  diagramView: initialDiagramView,
  activeDetailTab: WorkOrderDetailTab.VEHICLE_DETAILS,
};
